// extracted by mini-css-extract-plugin
module.exports = {"R3Page":"ProductContent_R3Page__F0lfO"};